import React, { useState, useEffect } from 'react';
import {
  Spinner,
  Tabs,
  WarningCircleFilledIcon,
} from '@forgeglobal/design-framework';
import TabContent from '@tcs/common/components/atoms/TabContent';
import Header from '@tcs/client-portal-common/components/organisms/Header';
import ProfileSecurity from '@tcs/client-portal-common/components/templates/ProfileSecurity';
import ProfileSettings from '@tcs/client-portal-common/components/templates/ProfileSettings';
import PasswordSuccessBanner from '@tcs/client-portal-common/components/molecules/PasswordSuccessBanner';
import PersonalInfo from '@tcs/client-portal-common/components/templates/PersonalInfo';
import { useGetQuestion } from '@tcs/client-portal-common/hooks/auth';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import { Route } from 'react-router';
import useAccounts from '@tcs/client-portal-common/hooks/useAccounts';
import { useQueryClient } from 'react-query';
interface ProfileProps {
  setProfileSecurityQuestion: (value: string) => void;
}

const Profile = ({ setProfileSecurityQuestion }: ProfileProps) => {
  const { data: securityQuestion, loading: loadingQuestion } = useGetQuestion();
  const {
    claims: { clientPortalIdentity },
    profile,
  } = useSession();
  const [showMessage, setShowMessage] = useState('');
  const [question, setQuestion] = useState('');
  const queryClient = useQueryClient();

  useEffect(() => {
    setProfileSecurityQuestion(question);

    // force the get question query to run again
    queryClient.invalidateQueries({
      predicate: (query) =>
        query.queryKey
          .toString()
          .startsWith('/Authorization/Question/GetQuestion'),
    });
  }, [question]);

  function getProfileTabContent() {
    let icon = null;

    if (
      !loadingQuestion &&
      (Object.keys(securityQuestion).length === 0 ||
        securityQuestion.text === '') &&
      question === ''
    ) {
      icon = <WarningCircleFilledIcon fontSize="small" color="warning" />;
    }

    return (
      <TabContent
        label="Security"
        icon={icon}
        iconPosition={'end'}
        data-test-id="profile-security-tab">
        <ProfileSecurity
          loading={loadingQuestion}
          question={question || securityQuestion?.text}
          setQuestion={setQuestion}
          showMessage={setShowMessage}
        />
      </TabContent>
    );
  }

  return (
    <>
      <PasswordSuccessBanner
        message={showMessage}
        dismissMessage={() => setShowMessage('')}
      />
      <Header
        pageTitle="Profile"
        tabs={() => (
          <Tabs>
            <Route
              path="*"
              element={
                <TabContent
                  label="Personal Info"
                  data-test-id="profile-personal-info-tab">
                  <PersonalInfo profile={profile} />
                </TabContent>
              }
            />
            <Route path="/security" element={getProfileTabContent()} />
            <Route
              path="/settings"
              element={
                <TabContent
                  label="Settings"
                  data-test-id="profile-settings-tab">
                  <ProfileSettings accountNumber={clientPortalIdentity} />
                </TabContent>
              }
            />
          </Tabs>
        )}
      />
    </>
  );
};

export default Profile;
